<template>
  <div class="page">
    <mu-toast v-if="toast" v-bind:message="hintMsg" @close="hideToast" id="alertline" />
    <!--<mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh" />-->
    <pageTitle title='早餐券详情' />

    <!--主页面-->
    <div style="background-color:#F5F5F5 ; min-height:12.4rem">

      <div style="width:100% ; background-color:white;padding:0.2rem 0.35rem; line-height:2  ">
        <div style=' font-weight:bold ; font-size:0.3rem ;color:#333 ;'>
          {{ g_breakfastInfo.HotelName }}
        </div>
        <div style='  '>
          订单号：{{ g_breakfastInfo.breakfastResvNo }}
        </div>
        <div style='  '>
          创建时间：{{ g_breakfastInfo.createtimeText }}
        </div>

      </div>
      <div style='height: 0.2rem;'></div>

      <div  v-if="item.ticketNo!=''" v-on:click='LookCode( g_breakfastInfo.HotelCode,item.ticketNo )' v-for='(item,index) in g_breakfastInfo.AAListBag'>

        <div style="background-color:#fff; width:6.9rem; margin:0  0.3rem; padding-top:0.3rem ">

          <div style="   padding-left: 0.4rem; overflow:hidden; ">

            <div v-if=" item.statusText == '未使用' " style=" background-image: url(../../../static/user/Breakfast/LeftImg_1.png ); background-repeat:no-repeat;  background-size:  cover ;
                    width: 1.5rem ;height:0.9rem ; color:white ; float:left    ">
              <div style=" width:100% ;  text-align:center ; line-height:0.35rem;padding-top:0.1rem;margin-left:-0.03rem    ">
                <div style="   font-size:0.22rem ;   "> 早餐券 </div>
                <div style="  height:0.03rem ;   "> </div>
                <div style="   font-size:0.34rem   "> ￥{{ item.paymoney }} </div>
              </div>
            </div>

            <div v-if=" item.statusText != '未使用' " style=" background-image: url(../../../static/user/Breakfast/LeftImg_2.png ); background-repeat:no-repeat;  background-size:  cover ;
                    width: 1.5rem ;height:0.9rem ; color:white ; float:left    ">
              <div style=" width:100% ;  text-align:center ; line-height:0.35rem;padding-top:0.1rem;margin-left:-0.03rem    ">
                <div style="   font-size:0.22rem ;   "> 早餐券 </div>
                <div style="  height:0.03rem ;   "> </div>
                <div style="   font-size:0.34rem   "> ￥{{ item.paymoney }} </div>
              </div>
            </div>

            <!--       -->
            <div style=" float:left  ;margin-left:0.2rem ; font-size:0.24rem;  line-height:0.4rem ; padding-top:0.04rem ; color:#666 ;">
              <div style="  "> 有效日期 : {{ item.effectiveDate }} </div>
              <div  v-if=" item.statusText == '已使用' " style="  "> 使用日期 : {{ item.useDate }} </div>
              <div  v-else style=" padding-top:0.05rem "> 券<span style="color:white">券码</span>码 : {{ item.ticketNo }} </div>
            </div>

            <div  v-if="item.statusText == '已过期'"   style=" background-image: url(../../../static/user/Breakfast/outdate.png ); background-repeat:no-repeat;  background-size:  cover ;
                    width: 1.9rem ;   position:absolute ; right:0.5rem ;height:1.6rem   ">
            </div>
            <div  v-if="item.statusText == '已使用'"   style=" background-image: url(../../../static/user/Breakfast/used.png ); background-repeat:no-repeat;  background-size:  cover ;
                    width: 1.9rem ;   position:absolute ; right:0.5rem ;height:1.6rem   ">
            </div>
            <div  v-if="item.statusText == '已作废'"   style=" background-image: url(../../../static/user/Breakfast/invalid.png ); background-repeat:no-repeat;  background-size:  cover ;
                    width: 1.9rem ;   position:absolute ; right:0.5rem ;height:1.6rem ; z-index:1  ">
            </div>

          </div>

          <div style="color:#ff9347 ; font-size:0.29rem;  ;   border-top: solid 1px #f3f3f3  ; margin-top:0.25rem    ; padding:0.2rem  ; text-align:center ">
            查看券码
          </div>

        </div>

        <!--     <div style="      ">              </div>        -->
        <div style='height: 0.2rem;'></div>
      </div>

      <!--阴影页面，显示二维码和券码-->
      <div id="bg_show" style=" position:fixed " v-if="Code2dStr != ''" v-on:click="CleanShadow()"> </div>

      <div v-if="Code2dStr != ''" class="pr container" style="z-index: 1003; position: fixed; top: 1.8rem; width: 7.5rem; ">

        <div style=" text-align:center ; margin:0 auto ;  width:6rem    ">

          <div style=" background-image: url( ../../../static/user/Breakfast/2DCode.png ) ;background-size: 6rem;
              background-repeat:no-repeat;  height: 6.5rem ;  ">
            <div style="    color: #FEFFFD; font-size:0.29rem  ">

              <img v-bind:src="Code2dImg" style=" width:4.5rem ; min-height:4.5rem; margin-top:0.5rem " />

              <div style='height: 0.5rem;'></div>

              <div style=' color:#666 ; font-size:0.3rem'>
                券码：{{Code2dStr}}
              </div>

            </div>
          </div>
        </div>
      </div>


      <div style='height: 0.1rem;'></div>

    </div>

    <!--<div v-if='vo.Status == "0" && g_currentOrder.freeVoucherInfo.useNotSee' v-bind:class="{ 'active': vo.selected }" class='fBtn'></div>-->

  </div>
</template>





<script>
import api from '../../api'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import loadListTail from '../../components/loadListTail'
import Scroll from '../../utils/loading'
export default {
  data() {
    return {

      NowUser: "",

      activeTab: '0',

      Code2dStr: '',
      Code2dImg: '',

      dialog: false,
      toast: false,

      NameList: [[], [], []],


      loadState: [
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        }
      ],
      hintMsg: '',
      pageSize: 10,
      refreshing: false,
      trigger: null,
      couponCode: '',
      scroll: null
    }
  },
  activated() {


    if (this.NowUser != this.g_UserInfo.Card_no) {

      this.NowUser = this.g_UserInfo.Card_no;

      // this.scroll.initLoadState()



    }

  },


  components: {
    loadListTail
  },
  methods: {
    ...mapMutations(['setG_currentOrder'
    ]),
    initData() {



      //初始化本页控制数据、分页参数
      this.scroll.refresh()
    },
    refresh() {
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
        this.initData()
      }, 2000)
    },
    //获取 早餐券
    getData() {
      var Tab = this.activeTab
      var that = this
      var params = new this.URLSearchParam();
      params.append('pageIndex', this.pageParam[Tab].index);
      params.append('pageSize', this.pageSize);
      params.append('useType', Tab);
      //useType  =  未使用0，已使用1，已过期2，已作废 3

      return new Promise(function(resolve, reject) {
        that.$http.post(api.GetBreakfastTicketList(), params.toParam()).then((res) => {
          if (res.Result) {
            // var temp = res.Data.Data.GetBreakfastTicketListResult

            // var Names = res.Data.Data.InfoList

            // if (temp == null) {
            //   resolve(null)
            // }
            // else {
            //   // that.initFreeVOuchers(temp)
            //   resolve(temp.length)
            //   that.BreakfastList[Tab] = that.BreakfastList[Tab].concat(temp)

            //   that.NameList[Tab] = that.NameList[Tab].concat(Names)
            // }
          }
          else {
            resolve(null)
            that.hintMsg = res.Message
            that.showToast()
          }
        })
      })
    },
    //三个分页
    handleTabChange(val) {



      this.activeTab = val;

      console.log(this.activeTab)
      this.scroll.changeType(val)
    },


    LookCode(a, b) {


      this.Code2dStr = b;

      this.Code2dImg = api.Code2D(a + '|' + b);

    },


    CleanShadow() {
      this.Code2dStr = '';

      // // 恢复
      // document.body.style.overflow = 'auto';
      // function _preventDefault(e) { e.preventDefault(); }
      // window.removeEventListener('touchmove', _preventDefault);
    },



    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
      if (this.hintMsg == '请先登录') {
        console.log(this.hintMsg)
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1800)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },






  },
  computed: {
    ...mapGetters(['g_UserInfo', 'g_currentOrder', 'g_searchParam', 'g_breakfastInfo']),
    // freeAmount() {
    //   var tempAmount = 0
    //   this.BreakfastList.forEach((item, index, array) => {
    //     if (item.selected) {
    //       tempAmount += Number(item.Amount)
    //     }
    //   })
    //   return tempAmount
    // }
  },
}
</script>







<style lang="less" scoped>
@import "../../assets/theme.less";

.mu-tabs {
  // 背景色
  background-color: #fff;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中  分页的
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
</style>







// WEBPACK FOOTER //
// BreakfastDetails.vue?115f7fe0